/**
 * @generated SignedSource<<d93528102407d8ffa2dd3fe7b7fdbf37>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useUpdateAssetTimestampMutation$variables = {
  assetId: UUID;
};
export type useUpdateAssetTimestampMutation$data = {
  readonly assetImageModified: {
    readonly clientMutationId: string | null | undefined;
  } | null | undefined;
};
export type useUpdateAssetTimestampMutation = {
  response: useUpdateAssetTimestampMutation$data;
  variables: useUpdateAssetTimestampMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "assetId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "assetId",
            "variableName": "assetId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "AssetImageModifiedPayload",
    "kind": "LinkedField",
    "name": "assetImageModified",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUpdateAssetTimestampMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUpdateAssetTimestampMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "93389252842c862e631e284162e3fbdd",
    "id": null,
    "metadata": {},
    "name": "useUpdateAssetTimestampMutation",
    "operationKind": "mutation",
    "text": "mutation useUpdateAssetTimestampMutation(\n  $assetId: UUID!\n) {\n  assetImageModified(input: {assetId: $assetId}) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "7fa7a8807a63d13f9c0a70b68e50e45c";

export default node;
